import { render, staticRenderFns } from "./smallCourseCard.vue?vue&type=template&id=69e14a32&"
import script from "./smallCourseCard.vue?vue&type=script&lang=js&"
export * from "./smallCourseCard.vue?vue&type=script&lang=js&"
import style0 from "./smallCourseCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports